import React from 'react';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Feature from '../../components/feature';

import DataImg from './../../assets/img/data.png';
import CloudImg from './../../assets/img/office.png';
import MeasurementImg from './../../assets/img/measurement.png';
import SetupImg from './../../assets/img/setup.png';
import ScalabilityImg from './../../assets/img/scalability.png';
import ProactiveImg from './../../assets/img/proactive.png';

import './style.scss';
export default function Home() {
  return (
    <div className="container">
      <Header />
      <div className="content">
        <div className="section-1">
          <div className="two-col">
            <div className="paragraph">
              <div className="paragraph-heading">1 What is CloudVik?</div>
              <div className="paragraph-desc">
                <div className="segment">
                  CloudVik is a computing platform, including both hardware and
                  software, for distributed parallel processing of a vast amount
                  of heterogenous automotive measurement data.
                </div>
                <div className="segment">
                  It is a tailor made custom solution, built on top of proven,
                  state of the art technologies, customized for automotive
                  development and testing teams. It is used to store, manage and
                  analyze data, when single computers provide no more sufficient
                  processing power to derive important information from those
                  data.
                </div>
                <div className="segment">
                  Physically, it is computer cluster suitable for office,
                  laboratory or the distant driving area. It ingests and stores
                  measurement files (mdf, blf, TDMS, csv…) from different tools
                  (CANape, CANoe, Matlab, LabView, BrickPC, ...) into own
                  highly-scalable distributed storage (HDFS).
                </div>
              </div>
            </div>
          </div>
          <div className="tow-col">
            <div>
              <div
                className="paragraph paragraph-2"
                style={{ backgroundColor: '#f2f2f2' }}
              >
                <div className="paragraph-heading">2 What is SUPRABYTES?</div>
                <div
                  className="paragraph-desc"
                  style={{ marginBottom: 19, marginTop: 4 }}
                >
                  A brand Suprabytes is built with vision of applying newest
                  available technologies and computing paradigms for
                  significantly improving way of work in analysis of automotive
                  data. It provides development- and testing-teams in automotive
                  industry very fast and cost effective, machine learning
                  capable, data processing systems that help users to quickly
                  extract important information and get complete picture about
                  the performance of observed systems.
                </div>
              </div>
              <div className="paragraph" style={{ marginTop: 15 }}>
                <div className="paragraph-desc">
                  Team members are performing data mining through graphical
                  interface from their windows desktops or through web
                  interface, independent of operating system. This allows
                  centralized processing in a parallel way while results are
                  provided within a reasonable time.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="feature-section">
          <Feature
            img={DataImg}
            title={'Big data'}
            desc="Sufficient computational power and right speed to process heterogenous data"
          />
          <Feature
            img={CloudImg}
            title={'Office Cloud'}
            desc="Consist of several computers that can be physically placed in office, lab or at driving site"
          />
          <Feature
            img={MeasurementImg}
            title={'Measurement data'}
            desc="Stores measurement files  into own highly-scalable distributed storage with data replication"
          />
        </div>
        <div className="section">
          <div className="paragraph">
            <div className="paragraph-heading">3 Overview of Advantages</div>
            <div
              className="paragraph-desc"
              style={{
                justifyContent: 'space-around',
                display: 'flex',
                flexWrap: 'wrap',
              }}
            >
              <div className="two-col">
                <ul>
                  <li>
                    CloudVik is fully prepared environment computer-cluster,
                    ready to import measurement data.
                  </li>
                  <li>
                    CloudVik contains configured tools from Hadoop stack for
                    parallel processing.
                  </li>
                  <li>
                    CloudVik solves problem of growing data requirements:
                    Scalable volume (TB, PB), Change velocity (real time data
                    acquisition, automatic/periodic or triggered data updates),
                    Variety (signals, 2D-maps, 3D, photos, videos, GPS, audio,…)
                    and Veracity (can handle dirty uncomplete data).
                  </li>
                  <li>
                    Data is stored with selectable replication factor, which
                    makes it resilient to one or more node failures.
                  </li>
                </ul>
              </div>
              <div className="two-col">
                <ul>
                  <li>
                    CloudVik web based interface works on Windows and Linux
                    desktops, providing notebook based GUI for executing already
                    prepared and own scripts.
                  </li>
                  <li>
                    CloudVik cluster already contains useful automotive data
                    analysis and data mining examples, prepared in a way that
                    parametrization and change of function-ality is quick and
                    easy. For creation of special cases Suprabytes provides
                    support or Support-project.
                  </li>
                  <li>
                    CloudVik is fully prepared environment, Suprabytes mission
                    is to support you on your way to efficiently manage
                    distributed processing of high quantities of complex data.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="section" style={{ marginTop: -4 }}>
          <div className="paragraph">
            <div className="paragraph-heading">4 Options</div>
            <div className="paragraph-desc">
              <ul>
                <li>
                  <div style={{ display: 'flex' }}>
                    <div className="paragraph-left">Machine-Learning:</div>
                    <div className="paragraph-right">
                      Supervised - specify what to recognize without having an
                      algorithm. Unsupervised - machine observes the data and
                      extracts anomalies.
                    </div>
                  </div>
                </li>
                <li>
                  <div style={{ display: 'flex' }}>
                    <div className="paragraph-left">Data Streaming:</div>
                    <div className="paragraph-right">
                      Live data recordings with real-time data analysis and
                      anomaly detections executed with minimal latency.
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="feature-section">
          <Feature
            img={SetupImg}
            title={'Setup HW/SW'}
            desc="CloudVik is already setup environment that can be used immediately."
          />
          <Feature
            img={ScalabilityImg}
            title={'High scalability'}
            desc="It has easily scalable storage and processing for various data types"
          />
          <Feature
            img={ProactiveImg}
            title={'Proactive support'}
            desc="Ready to help and customize:  automotive functions, programming support, apps development, machine learning, etc."
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
